import * as React from 'react';
import { Breakpoints } from '../../../../shared/styles/StyleConst';
import AdultNumberInput from './AdultInput';
import ChildInput from './ChildInput';
import { SearchRoomCondition } from '../../../../models/search/SearchCondition';

type Props = {
  rooms: SearchRoomCondition[];
  onChange: (rooms: SearchRoomCondition[]) => void;
  onChildModifyComplete: (isComplete: boolean) => void;
  isChildAgeChecked: boolean;
};

export default class GuestNumberContent extends React.Component<Props> {
  render() {
    const { rooms, onChange, onChildModifyComplete, isChildAgeChecked } = this.props;
    return (
      <React.Fragment>
        <div className="guest-number-container">
          <AdultNumberInput rooms={rooms} onChange={onChange} />
          <ChildInput
            rooms={rooms}
            onChange={onChange}
            onChildModifyComplete={onChildModifyComplete}
            isChildAgeChecked={isChildAgeChecked}
          />
        </div>
        <style jsx>
          {`
            .guest-number-container {
              width: 100%;
              height: auto;
              background: #ffffff;
              padding: 20px;
              justify-content: center;
              display: flex;
              flex-wrap: wrap;
            }
            @media screen and (min-width: ${Breakpoints.smMin}) {
              .guest-number-container {
                padding: 10px 20px 20px 20px;
              }
            }
          `}
        </style>
      </React.Fragment>
    );
  }
}
